<template>
  <div>
    <span v-if="inrValue!=null">
    <strong v-if="enableDecimal">
      <!-- {{ inrValue!=null?(inrValue | inrWithDecimal):'--' }} -->
      {{ inrValue | inrWithDecimal }}
    </strong>
    <strong v-else-if="enableIndianNotation">
      <!-- {{ inrValue!=null?(inrValue | inrWithDecimal):'--' }} -->
      {{ inrValue | indianNotation }}
    </strong>
    
    <strong v-else>
      <!-- {{inrValue!=null?(inrValue | toINR):'--'}} -->
      {{ inrValue | toINR }}
    </strong>
    </span>
    <span v-else>
      --
    </span>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import ModelVue from "../../ModelVue";

@Component({
  components: {},
})
export default class FCellCurrency extends ModelVue {
  @Prop()
  dataSelectorKey: string;

  @Prop()
  rounded: boolean;

  @Prop()
  enableDecimal: boolean;
  
  @Prop()
  enableIndianNotation: boolean;

  get inrValue() {
    return this.rounded
      ? Math.round(this.selectModel(this.modelValue || 0, this.dataSelectorKey))
      : this.selectModel(this.modelValue || 0, this.dataSelectorKey);
  }
}
</script>
